module.exports = __webpack_public_path__ + "img/jorge-mercado.4ddc50ea.jpg";